import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { apiFetch, setToken } from "@/api";
import { Button, Field, Spinner } from "@/ui";
import { LEARNING_LEVELS } from "@/constants";

const shell = "flex min-h-screen items-center justify-center bg-background px-6 text-foreground";

export default function Enroll() {
  const { key } = useParams();
  const [info, setInfo] = useState(null);
  const [name, setName] = useState("");
  const [level, setLevel] = useState("5th");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    (async () => {
      try { setInfo(await apiFetch(`/enroll/${key}`, { auth: false })); }
      catch (e) { setErr(e.message); }
      finally { setLoading(false); }
    })();
  }, [key]);

  const join = async () => {
    setErr("");
    if (!name.trim()) return setErr("Please enter your name.");
    setJoining(true);
    try {
      const data = await apiFetch(`/enroll/${key}`, { method: "POST", body: { name: name.trim(), learning_level: level }, auth: false });
      setToken(data.token);
      window.location.assign("/home");
    } catch (e) { setErr(e.message); setJoining(false); }
  };

  if (loading) return <div className={shell}><Spinner className="h-6 w-6 text-foreground" /></div>;

  return (
    <div className={shell}>
      <div className="w-full max-w-md flex flex-col gap-5">
        <img src="/maxx-logo-ondark.png" alt="MAXx" className="h-11 w-auto self-start" />
        {info && !info.ok ? (
          <>
            <h1 className="text-2xl font-semibold tracking-tight">Can't join right now</h1>
            <p data-testid="enroll-blocked" className="text-muted-foreground">{info.reason || "This link isn't available."}</p>
          </>
        ) : info ? (
          <>
            <h1 className="text-2xl font-semibold tracking-tight">Join {info.school_name}</h1>
            <p className="text-sm text-muted-foreground">{info.teacher_name}'s class · enter your name to start using MAXx. No email or password needed.</p>
            <Field label="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="enroll-name" placeholder="First name + last initial" />
            <label className="flex flex-col gap-1.5">
              <span className="text-xs font-semibold text-muted-foreground">Your grade / level</span>
              <select data-testid="enroll-level" value={level} onChange={(e) => setLevel(e.target.value)} className="w-full rounded-xl border border-input bg-background px-4 py-3 text-[15px] outline-none">
                {LEARNING_LEVELS.map((l) => <option key={l} value={l}>{l}</option>)}
              </select>
            </label>
            {err ? <p data-testid="enroll-error" className="text-sm font-semibold">{err}</p> : null}
            <Button data-testid="enroll-join" onClick={join} loading={joining}>Join the class</Button>
          </>
        ) : (
          <p data-testid="enroll-error" className="text-sm font-semibold">{err || "Something went wrong."}</p>
        )}
      </div>
    </div>
  );
}

export function StudentRelogin() {
  const { token } = useParams();
  const [err, setErr] = useState("");
  useEffect(() => {
    (async () => {
      try {
        const data = await apiFetch("/enroll/relogin", { method: "POST", body: { token }, auth: false });
        setToken(data.token);
        window.location.assign("/home");
      } catch (e) { setErr(e.message); }
    })();
  }, [token]);
  return (
    <div className={shell}>
      {err ? <p data-testid="relogin-error" className="max-w-md text-center text-sm font-semibold">{err}</p> : <Spinner className="h-6 w-6 text-foreground" />}
    </div>
  );
}
